module.exports = __webpack_public_path__ + "img/mena-moon.74aab5a1.svg";